<template>
    <div class="c-api-visualizing">
        <div
            v-if="content"
            class="c-api-visualizing__content"
        >
            <div
                v-if="!showVideo"
                class="c-api-visualizing__content__cover"
                :style="{ backgroundImage: `url(${content.header_image.link ? content.header_image.link : content.image.link})` }"
            >
                <div class="c-api-visualizing__content__cover__text-box">
                    <p
                        v-if="!dontShowContent"
                        class="description pa-1"
                        v-html="content.synopsis"
                    />
                    <img
                        src="@/assets/images/play.svg"
                        :alt="$t('home.watch_now')"
                        @click="showVideo = true"
                    >
                </div>
            </div>
            <div
                v-for="(album, index) in content.albums.filter(g=> g.group === 'video')"
                v-else
                :key="`responsive-choose-us-${index}`"
                class="c-api-visualizing__content__video"
            >
                <y-player :src="album.link" />
            </div>
        </div>

        <div class="c-api-visualizing__content__cta">
            <y-button
                :tag="isLink(content.custom['field6']) ? 'a' : 'router-link'"
                :href="content.custom['field6']"
                :to="content.custom['field6']"
                :content="content.custom['field5']"
                color="primary"
                size="medium"
                flat
                no-padding
            />
        </div>
    </div>
</template>

<script>
    import { YPlayer } from '@groot-components/all';
    import { isLink } from '@/helpers/helpers';

    export default {
        name      : 'Visualization',
        components: { YPlayer },
        props     : {
            content        : Object,
            dontShowContent: Boolean,
        },
        /**
         * @inheritDoc
         */
        data() {
            return {
                showVideo: false,
            };
        },
        methods: {
            isLink,
        },
    };
</script>

<style lang="scss" src="./visualizing.scss"></style>
